import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4285F4',
    },
    secondary: {
      main: '#42F456',
    },
    background: {
      default: '#E3D8F2', // darker purple background
      paper: '#FFFFFF', // This is usually the background for components like Card, Paper, etc.
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#E3D8F2', 
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#FFFFFF', // Set AppBar background to white
        },
      },
    },
  },
});

export default theme;
